/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Listado from 'components/public/Listado/Listado';
import { titulosListadoTalleresDeUsuario } from 'utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { TallerBase, TallerListadoAlumno } from 'utils/models/types';
import { fetchTalleresDeUsuario } from 'utils/redux/features/talleresDeUsuarioSlice';
import { convertirFechasAHorarios, convertirFechasStringAFechas, formatearFechaParaListado } from 'utils/utilities';
import Spinner from 'components/public/Spinner/Spinner';

const MisTalleres = () => {
  const { talleresUsuario, loadingTalleresUsuario, errorTalleresUsuario } = useSelector(
    (state: RootState) => state.talleresDeUsuario
  );
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);
  const usuarioId = usuario.Id;
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchTalleresDeUsuario(Number(usuarioId)));
  }, [dispatch]);

  const talleresListado: TallerListadoAlumno[] = talleresUsuario.map((t: TallerBase) => {
    const horariosClasesEnDate = t.HorariosClases && t.HorariosClases.map(fecha => convertirFechasStringAFechas(fecha));
    const horariosFormateados = convertirFechasAHorarios(horariosClasesEnDate);
    const fechaInicio = t.HorariosClases && t.HorariosClases[0].FechaInicio;
    const fechaFin = t.HorariosClases && t.HorariosClases[t.HorariosClases.length - 1].FechaInicio;
    return {
      ...t,
      FechaInicio: fechaInicio && formatearFechaParaListado(fechaInicio),
      FechaFin: fechaFin && formatearFechaParaListado(fechaFin),
      Dias: horariosFormateados || '',
      DetallePath: `/taller/${t.Id}`,
    };
  });

  const error401 = errorTalleresUsuario?.includes('permisos');

  return loadingTalleresUsuario ? (
    <Spinner />
  ) : errorTalleresUsuario ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={talleresListado}
      headCells={titulosListadoTalleresDeUsuario}
      titulo="Mis talleres"
      loading={loadingTalleresUsuario}
    />
  );
};

export default MisTalleres;
